import { ArrowLeft, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-[#0D0D0D] text-white flex items-center justify-center">
      <div className="text-center px-6">
        <Link
          to="/"
          data-testid="coming-soon-back-link"
          className="inline-flex items-center gap-2 text-[#A0A0A0] hover:text-[#FF6B35] text-sm mb-12 transition-colors"
        >
          <ArrowLeft size={16} />
          Retour à l'accueil
        </Link>

        <div className="w-20 h-20 rounded-2xl bg-[#FF6B35]/10 flex items-center justify-center mx-auto mb-8">
          <Clock size={40} className="text-[#FF6B35]" />
        </div>

        <h1 className="font-['Poppins'] font-bold text-3xl sm:text-4xl mb-4">
          Un peu de patience !
        </h1>
        <p className="text-[#A0A0A0] text-base sm:text-lg max-w-md mx-auto mb-8">
          L'application ClayPulse sera bientôt disponible au téléchargement. Restez connecté !
        </p>

        <a
          href="mailto:supportclaypulse@gmail.com"
          data-testid="coming-soon-contact"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/10 text-white hover:bg-white/5 hover:border-[#FF6B35]/30 transition-all duration-300 text-sm font-medium"
        >
          Nous contacter
        </a>
      </div>
    </div>
  );
}
